var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_core.js
// module id = 27
// module chunks = 1